<template>
	<v-dialog v-model="selectGroupDialogVisible" width="600">
    <customDialog>
      <template v-slot:title>
        {{t('selectGroup')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="selectGroupDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
						<v-row class="ma-0 pa-0 mt-2 mb-14">
              <v-col id="store_list" class="ma-0 pa-0" cols="12">
								<template v-if="fetchLoading == false">
									<v-col class="ma-0 pa-0" cols="12"
										v-for="(item, index) in storeGroupList" :key="index">
										<v-row class="ma-0 pa-3 pt-1 pb-1" align="center"
											style="border-bottom: 1px solid #4A4A4A;">
											<input id="check_box" v-model="item.checked" type="checkbox" />
											<v-col class="ma-0 pa-0 ml-3" cols="auto" align="left"
												style="font-weight:bold;">
												{{item.groupName}}
											</v-col>
										</v-row>
									</v-col>
								</template>
								<template v-else>
									<v-col class="ma-0 pa-7" cols="12" align="center">
                    <v-progress-circular indeterminate color="white"
                      :width="4" :size="30"></v-progress-circular>
                  </v-col>
								</template>
							</v-col>
            </v-row>
						<v-row class="ma-0 pa-0" align="center" justify="center">
							<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
								id="grey_btn" elevation="0" @click="selectGroupDialogVisible = false">
									{{t('back')}}
							</v-btn>
							<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
								id="blue_btn" elevation="0" @click="requestAdd" :loading="addLoading">
									{{t('add')}}
							</v-btn>
						</v-row>
          </v-col> 
        </v-row>
      </template>
    </customDialog>

		<AddGroupResultDialog :dialogVisible="addGroupDialogVisible"
			@visible="addGroupDialogVisibleFunc" :msgList="resultMessageList" />
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
import AddGroupResultDialog from './AddGroupResultDialog.vue';
export default {
	props: {
		dialogVisible: Boolean,
		checkStore: Array,
	},
	components: {
		CustomDialog, AddGroupResultDialog
	},
	mixins: [mixin.common],
	data: () => ({
		selectGroupDialogVisible: false,
		addGroupDialogVisible: false,
		storeGroupList: [],
		fetchLoading: false,
		addLoading: false,
		resultMessageList: [],
	}),
	watch: {
    dialogVisible: function(item) {
      this.selectGroupDialogVisible = item;
			if(item) {
				this.fetchStoreGroupList();
				console.log('checked StoreList\n', this.checkStore);
			}
    },
    selectGroupDialogVisible: function(item) {
      this.$emit('visible', item);
    },
  },
	methods: {
		fetchStoreGroupList() {
			this.fetchLoading = true;
			let params = {};
			this.networkController.getStoreGroupAllData(params).then(async (res) => {
				console.log('%cFetch Store Group List\n', "color:#008DD0;", res.data);
				this.storeGroupList = [];
				let makeList = [];
				res.data.forEach((item) => {
					item.checked = false;
					makeList.push(item);
				});
				this.storeGroupList = makeList;
				this.fetchLoading = false;
			}).catch(error => {
				this.fetchLoading = false;
			});
		},
		requestAdd() {
			this.resultMessageList = [];
			let checkedStoreGroup = this.getCheckedStoreGroup();
			if(checkedStoreGroup.length == 0) return;
			this.addLoading = true;
			this.checkStore.forEach((checkStore, index) => {
				checkedStoreGroup.forEach((group) => {
					let duplicated = group.stores.findIndex((el, index, arr) => el.unisCustomerCd == checkStore.unisCustomerCd)
				  if(duplicated == -1) { // 점포그룹내 점포가 중복이 안되는 경우
						// console.log('그룹명-', group.groupName, ' 추가 가능');
						this.addToGroup(checkStore, group);
					} else {
						this.resultMessageList.push(`${checkStore.customerName}は既に${group.groupName}に登録されています。`);
						// console.log('그룹명-', group.groupName, ' 추가 불가');
					}
				});
				if(index == this.checkStore.length -1) {
					this.goResult();
				}
			});
		},
		getCheckedStoreGroup() {
			let result = [];
			this.storeGroupList.forEach((group) => {
				if(group.checked) result.push(group);
			});
			return result;
		},
		addToGroup(checkStore, group) {
      let storeList = group.stores;
      storeList.push({
				customerName : checkStore.customerName,
				unisCustomerCd: checkStore.unisCustomerCd
			});
			const params = {
        groupName: group.groupName,
				stores: storeList,
			};
			this.networkController.updateStoreGroup(params, group.id)
			.then(async (res) => {
				this.resultMessageList.push(`${checkStore.customerName}を${group.groupName}に追加しました。`);
			}).catch(error => { });
		},
		goResult() {
			setTimeout(() => {
				this.addLoading = false;
				this.addGroupDialogVisible = true;
			}, 1000);
		},
		addGroupDialogVisibleFunc(visible) {
      this.addGroupDialogVisible = visible;
			if(visible == false) this.selectGroupDialogVisible = false;
    },
	},
}
</script>

<style lang="scss" scoped>
#store_list {
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  width: 100%;
  min-height: 350px;
	max-height: 350px;
	overflow: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
</style>